import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";

import { Content } from "@/features/dashboard/configuracoes/termos/$id/components/TermsContent";

export const Route = createFileRoute("/_private/dashboard/_settings/configuracoes/termos/$id/modal")({
  component: ModalOrder
});

function ModalOrder() {
  return (
    <BaseEditCreateModal title="Editar Termos" from="/dashboard/configuracoes/termos/$id">
      <Content />
    </BaseEditCreateModal>
  );
}
